export default __webpack_public_path__ + "static/media/8-8-15-maze.9c9165e5.m4a";